import React from "react";
import salesImg from "../../../assets/images/sales.png";

const SalesImageSection = () => (
  <div className="col-12 col-lg-6">
    <img
      className="w-100 AuthlandingImg h_550x object-fit-cover br_25"
      src={salesImg}
      alt="Sales"
    />
  </div>
);

export default SalesImageSection;
